import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { ArrowLeft, Shield, Lock, Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

const SecuriteProtectionDonnees = () => {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <Link
            to="/guides"
            data-discover="true"
            className="inline-flex items-center text-toxic-green hover:text-opacity-80 mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour aux guides
          </Link>

          <article className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Sécurité et Protection des Données
            </h1>

            <div className="prose prose-invert max-w-none">
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Quand vous pariez en ligne, vous confiez des informations personnelles et financières sensibles à une plateforme. Comprendre comment ces données sont protégées, quels sont vos droits, et comment vous protéger vous-même est essentiel. Ce guide vous donne toutes les informations nécessaires pour parier en toute sécurité.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                L'Agrément ANJ : Votre Première Protection
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les plateformes agréées par l'Autorité Nationale des Jeux sont soumises à des normes strictes en matière de sécurité et de protection des données. Elles doivent utiliser des systèmes de cryptage avancés, protéger les données financières, et respecter le RGPD (Règlement Général sur la Protection des Données). Ne pariez jamais sur une plateforme non agréée - vous n'avez aucune garantie de protection.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                L'agrément ANJ garantit aussi que la plateforme est régulièrement audité, que ses systèmes sont sécurisés, et qu'elle dispose de procédures pour gérer les incidents de sécurité. C'est votre première et plus importante protection.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Le Cryptage SSL/TLS
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Toutes les plateformes agréées utilisent le cryptage SSL/TLS pour protéger les données transmises entre votre navigateur et leurs serveurs. Vous pouvez vérifier cela en regardant l'URL : elle doit commencer par "https://" et non "http://". Un cadenas dans la barre d'adresse indique aussi que la connexion est sécurisée.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ce cryptage protège vos identifiants de connexion, vos informations de paiement, et toutes les données que vous transmettez. Sans lui, vos informations pourraient être interceptées par des tiers malveillants. Ne jamais utiliser une plateforme qui n'utilise pas le cryptage SSL.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Protéger Vos Identifiants
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Votre mot de passe est la clé de votre compte. Choisissez un mot de passe fort, unique, et ne le réutilisez jamais sur d'autres sites. Un mot de passe fort contient au moins 12 caractères, mélange majuscules, minuscules, chiffres et symboles. Évitez les mots du dictionnaire, les dates personnelles, ou les séquences évidentes.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Activez l'authentification à deux facteurs (2FA) si la plateforme le propose. Cela ajoute une couche de sécurité supplémentaire : même si quelqu'un obtient votre mot de passe, il ne pourra pas accéder à votre compte sans votre téléphone ou votre application d'authentification.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ne partagez jamais vos identifiants avec qui que ce soit, même des amis ou de la famille. Les plateformes interdisent le partage de comptes, et si votre compte est compromis, vous serez responsable des actions effectuées.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Vos Données Personnelles et le RGPD
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Le RGPD vous donne des droits importants sur vos données personnelles. Vous avez le droit de savoir quelles données sont collectées, comment elles sont utilisées, et avec qui elles sont partagées. Vous avez le droit d'accéder à vos données, de les corriger, de les supprimer, et de vous opposer à leur traitement.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les plateformes agréées doivent vous informer clairement de leur politique de confidentialité. Lisez-la avant de créer un compte. Vérifiez quelles données sont collectées (nom, adresse, email, numéro de téléphone, données de paiement, historique de paris), comment elles sont utilisées (pour gérer votre compte, pour la prévention de la fraude, pour le marketing), et avec qui elles sont partagées.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vous pouvez demander une copie de toutes vos données à tout moment. Vous pouvez aussi demander la suppression de votre compte et de vos données, sous réserve des obligations légales de conservation (les plateformes doivent conserver certaines données pour des raisons fiscales et de prévention de la fraude).
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Méthodes de Paiement Sécurisées
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les plateformes agréées utilisent des processeurs de paiement certifiés (PCI DSS) qui respectent les normes les plus strictes en matière de sécurité des données financières. Vos informations de carte bancaire sont cryptées et stockées de manière sécurisée, ou mieux encore, ne sont pas stockées du tout et sont transmises directement au processeur.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Certaines plateformes offrent l'option de ne pas enregistrer vos données de carte, ce qui est plus sûr. Vous devrez les saisir à chaque transaction, mais vos données ne seront jamais stockées sur leurs serveurs. C'est l'option la plus sécurisée.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les portefeuilles électroniques (PayPal, Skrill, Neteller) ajoutent une couche de protection supplémentaire : vous ne transmettez jamais vos informations bancaires directement à la plateforme de paris. Vous les transmettez au portefeuille, qui gère ensuite les transactions.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Reconnaître les Tentatives de Phishing
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les fraudeurs tentent souvent d'obtenir vos identifiants en se faisant passer pour une plateforme légitime. Ils envoient des emails qui semblent officiels, avec des liens vers des sites qui ressemblent au vrai site. Ne cliquez jamais sur des liens dans des emails suspects.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les plateformes légitimes ne vous demanderont jamais votre mot de passe par email. Si vous recevez un email qui semble suspect, allez directement sur le site officiel (en tapant l'URL vous-même) et connectez-vous pour vérifier. Ne jamais utiliser les liens dans les emails pour accéder à votre compte.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vérifiez toujours l'URL du site. Les sites de phishing utilisent souvent des URLs similaires mais légèrement différentes. Si vous n'êtes pas sûr, tapez l'URL vous-même ou utilisez un bookmark que vous avez créé vous-même.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Protéger Votre Appareil
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Votre sécurité dépend aussi de la sécurité de votre appareil. Utilisez un antivirus à jour, gardez votre système d'exploitation et vos navigateurs à jour, et évitez d'utiliser des réseaux Wi-Fi publics pour accéder à votre compte de paris. Les réseaux publics peuvent être interceptés par des tiers malveillants.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Si vous devez utiliser un appareil partagé, déconnectez-vous toujours après utilisation et effacez l'historique de navigation. Ne cochez jamais l'option "se souvenir de moi" sur un appareil partagé.
              </p>

              <div className="bg-toxic-green/10 border border-toxic-green/30 rounded-xl p-6 mt-12">
                <h3 className="text-2xl font-bold mb-4 text-white flex items-center">
                  <Shield className="w-6 h-6 text-toxic-green mr-3" />
                  Checklist de Sécurité
                </h3>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Vérifiez toujours que la plateforme est agréée ANJ</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Utilisez un mot de passe fort et unique, activez la 2FA</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Vérifiez que l'URL commence par "https://"</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Ne cliquez jamais sur des liens dans des emails suspects</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Protégez votre appareil avec un antivirus et des mises à jour</span>
                  </li>
                </ul>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SecuriteProtectionDonnees;

